import {
  BLOCK_EVENTS_QUERY_KEY,
  GET_BLOCK_VIDEO_EVENTS_QUERY_KEY,
  GET_MAPPED_EVENTS_MANAGEMENT_LIST,
  GET_MAPPED_EVENTS_QUERY_KEY,
  GET_MAPPED_EVENT_BY_ID,
  GET_MAPPED_STATUS_EVENT_QUERY_KEY,
  GET_NETWORK_CONFIGURES,
  GET_PRESET_LIST_KEY,
  GET_DATA_TRANSFORM,
} from '@api/emp/queryHooks';
import { MAPPED_EVENT_LIMIT_QUERY_KEY } from '@components/common/RulesBuilder/MappedEventBuilder/api';
import { METRIC_LIST_QUERY_KEY } from '@components/metrics-builder/api/queryHooks';
import {
  CUSTOM_DIMENSION_LIST,
  DIMENSION_LIST,
  GET_FLOW_LIST,
  GET_MAPPED_EVENT_NAMES,
  GET_FLOW_MANAGEMENT_LIST,
  GET_METRIC_DETAIL_IN_MANAGEMENT,
  GET_METRIC_MANAGEMENT_LIST,
  GET_RAW_CONFIG,
  GET_REMAIN_COUNT,
  USE_CUSTOM_DIMENSION_MANAGEMENT_LIST,
  GET_EVENT_LIST_FOR_METRIC,
  USER_DEFINED_CUSTOM_DIMENSION,
  GET_SENSITIVE_CONFIG,
  GET_SENSITIVE_CONFIG_META,
} from '@src/emp-3.0/utils/constants';
import { queryClient } from '@src/routers/constants';

export const refetchMappedEventRelated = () => {
  queryClient.invalidateQueries([MAPPED_EVENT_LIMIT_QUERY_KEY], { refetchInactive: true });
  queryClient.invalidateQueries([GET_MAPPED_EVENTS_QUERY_KEY], { refetchInactive: true });
  queryClient.invalidateQueries(['getMappedEventMetadataEventName'], { refetchInactive: true });
  queryClient.invalidateQueries([GET_MAPPED_STATUS_EVENT_QUERY_KEY], { refetchInactive: true });
  queryClient.invalidateQueries([GET_MAPPED_EVENTS_MANAGEMENT_LIST], { refetchInactive: true });
  queryClient.invalidateQueries([GET_EVENT_LIST_FOR_METRIC], { refetchInactive: true });

  queryClient.invalidateQueries([GET_MAPPED_EVENT_BY_ID]);
};

export const refetchMetricRelated = () => {
  queryClient.invalidateQueries([GET_MAPPED_EVENT_BY_ID]);
  queryClient.invalidateQueries([METRIC_LIST_QUERY_KEY], { refetchInactive: true });
  queryClient.invalidateQueries([GET_MAPPED_EVENTS_QUERY_KEY], { refetchInactive: true });
  queryClient.invalidateQueries([GET_MAPPED_EVENTS_MANAGEMENT_LIST], { refetchInactive: true });
  queryClient.invalidateQueries([GET_METRIC_MANAGEMENT_LIST], { refetchInactive: true });
  queryClient.invalidateQueries([GET_FLOW_LIST], { refetchInactive: true });
};

export const refetchDimensionRelated = () => {
  queryClient.invalidateQueries([GET_PRESET_LIST_KEY]);
  queryClient.invalidateQueries([DIMENSION_LIST], { refetchInactive: true });
  queryClient.invalidateQueries([CUSTOM_DIMENSION_LIST]);
  queryClient.invalidateQueries([USE_CUSTOM_DIMENSION_MANAGEMENT_LIST]);
  queryClient.invalidateQueries([GET_REMAIN_COUNT]);
  queryClient.invalidateQueries([GET_MAPPED_EVENT_NAMES]);
  queryClient.invalidateQueries([USER_DEFINED_CUSTOM_DIMENSION], { refetchActive: false });
  queryClient.invalidateQueries([GET_DATA_TRANSFORM]);
};

export const refetchRawConfigRelated = () => {
  queryClient.invalidateQueries([GET_RAW_CONFIG]);
  queryClient.invalidateQueries([BLOCK_EVENTS_QUERY_KEY]);
  queryClient.invalidateQueries([GET_BLOCK_VIDEO_EVENTS_QUERY_KEY]);

};

export const refetchFlowRelated = () => {
  queryClient.invalidateQueries([GET_FLOW_MANAGEMENT_LIST]);
  queryClient.invalidateQueries([GET_METRIC_DETAIL_IN_MANAGEMENT]);
};

export const refetchSensitiveConfigRelated = () => {
  queryClient.invalidateQueries([GET_SENSITIVE_CONFIG]);
  queryClient.invalidateQueries([GET_SENSITIVE_CONFIG_META]);
};